import React from 'react';
import { useLocation } from 'react-router-dom';
import { Lock, AlertCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { startGoogleLogin } from '../lib/auth';
import { companyInfo } from '../data/mock';
import { useDocumentMeta } from '../lib/useDocumentMeta';

const GoogleIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
  </svg>
);

const AdminLogin = () => {
  const location = useLocation();
  const error = location.state?.error;

  useDocumentMeta({
    title: 'Admin — SMT Services',
    description: 'Espace administrateur SMT Services.',
    path: '/admin/login',
    noindex: true,
  });

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-orange-50 flex items-center justify-center p-4">
      <div className="absolute top-20 left-10 w-72 h-72 bg-[hsl(207,90%,54%)] rounded-full opacity-10 blur-3xl pointer-events-none" />
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-[hsl(32,95%,55%)] rounded-full opacity-10 blur-3xl pointer-events-none" />

      <div className="relative w-full max-w-md bg-white rounded-3xl shadow-2xl p-8 sm:p-10">
        <div className="flex flex-col items-center text-center mb-8">
          <img src={companyInfo.logo} alt={companyInfo.name} className="h-20 w-auto mb-4" />
          <div className="inline-flex items-center gap-2 bg-blue-50 text-[hsl(207,90%,44%)] px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-3">
            <Lock className="w-3 h-3" />
            Espace Administrateur
          </div>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">Connexion</h1>
          <p className="text-gray-500 mt-2 text-sm">
            Connectez-vous avec votre compte Google pour accéder au tableau de bord.
          </p>
        </div>

        {error && (
          <div
            data-testid="login-error"
            className="mb-6 flex items-start gap-3 bg-red-50 border border-red-200 text-red-800 rounded-xl p-4 text-sm"
          >
            <AlertCircle className="w-5 h-5 shrink-0 mt-0.5" />
            <span>{error}</span>
          </div>
        )}

        <Button
          onClick={startGoogleLogin}
          data-testid="google-login-button"
          className="w-full h-12 bg-white hover:bg-gray-50 text-gray-800 font-semibold border-2 border-gray-200 hover:border-gray-300 shadow-sm hover:shadow-md transition-all"
        >
          <span className="flex items-center justify-center gap-3">
            <GoogleIcon />
            Continuer avec Google
          </span>
        </Button>

        <p className="text-xs text-gray-400 text-center mt-6">
          Seul le compte <strong className="text-gray-600">smt.services17t@gmail.com</strong> est autorisé.
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
